export default __webpack_public_path__ + "static/media/app-store-download.8c4986ee.svg";